// Carts do not reserve inventory. Never clear a customer's cart on a timer.
// Remove only the obsolete countdown state left by older theme versions.
(() => {
  try { localStorage.removeItem('cart_timestamp'); } catch (_) { /* Storage may be unavailable. */ }
  const removeLegacyTimer = () => document.getElementById('cart-timer')?.remove();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removeLegacyTimer, { once: true });
  } else {
    removeLegacyTimer();
  }
})();
